<template>
  <div class="kiosk-form-wrapper">
    <div class="form-groups">
      <div class="form-section">
        <div class="page-headercon">
          <div class="header-titlename">
            <h4 class="edit-company">{{ $t("companyDetails.form.edit") }}</h4>
            <svg
              style="
                margin-inline-end: 33px;
                float: inline-end;
                margin-top: -71px;
              "
              @click="$bvModal.hide('editEntity')"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="cursor-pointer"
            >
              <path
                d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                fill="#F46A6A"
              />
            </svg>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            @click="pickImage"
            :class="[logoError ? 'red-border' : '', 'camera-BG']"
            v-if="!logo.url"
          >
            <b-form-file
              accept="image/*"
              id="imagePicker"
              @change="onFileChange"
              class="d-none"
            ></b-form-file>
            <svg
              width="31"
              height="25"
              style="opacity: 0.65"
              viewBox="0 0 31 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                opacity="0.65"
                d="M10.4754 0L8.79936 3.37401H2.5141C1.12129 3.37401 0 4.50259 0 5.90451V21.931C0 23.3329 1.12129 24.4615 2.5141 24.4615H27.6551C29.0479 24.4615 30.1692 23.3329 30.1692 21.931V5.90451C30.1692 4.50259 29.0479 3.37401 27.6551 3.37401H21.3699L19.6938 0H10.4754ZM15.0846 7.59151C18.5559 7.59151 21.3699 10.4239 21.3699 13.9178C21.3699 17.4116 18.5559 20.244 15.0846 20.244C11.6134 20.244 8.79936 17.4116 8.79936 13.9178C8.79936 10.4239 11.6134 7.59151 15.0846 7.59151Z"
                fill="#8C8C8C"
              />
            </svg>
          </button>

          <div v-if="logo.url">
            <img :src="logo.url" class="img-company-bg" />
            <div class="img-bg__cover"></div>
            <b-form-file
              accept="image/*"
              id="imagePicker"
              @change="onFileChange"
              class="d-none"
            ></b-form-file>
            <span class="d-block">
              <svg
                width="31"
                height="25"
                @click="pickImage"
                style="
                  position: absolute;
                  top: 120px;
                  inset-inline-start: 48%;
                  color: #fff;
                  opacity: 0.65;
                "
                viewBox="0 0 31 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Vector"
                  opacity="0.65"
                  d="M10.4754 0L8.79936 3.37401H2.5141C1.12129 3.37401 0 4.50259 0 5.90451V21.931C0 23.3329 1.12129 24.4615 2.5141 24.4615H27.6551C29.0479 24.4615 30.1692 23.3329 30.1692 21.931V5.90451C30.1692 4.50259 29.0479 3.37401 27.6551 3.37401H21.3699L19.6938 0H10.4754ZM15.0846 7.59151C18.5559 7.59151 21.3699 10.4239 21.3699 13.9178C21.3699 17.4116 18.5559 20.244 15.0846 20.244C11.6134 20.244 8.79936 17.4116 8.79936 13.9178C8.79936 10.4239 11.6134 7.59151 15.0846 7.59151Z"
                  fill="white"
                />
              </svg>
              <button
                type="button"
                @click="removeImage()"
                class="remove-company-logo-btn"
              >
                {{ $t("common.remove") }}
              </button>
            </span>
          </div>

          <p class="text-muted" v-if="!logoError && !logo.url">
            <strong>{{ $t("common.notes.note") }}: </strong>
            {{ $t("companyDetails.notes.logo") }}
          </p>
          <p class="text-dangerr" v-if="logoError && !logo.url">
            <strong>{{ $t("common.notes.note") }}: </strong
            >{{ $t("common.notes.note.logoInstructionsUploadError") }}
          </p>
        </div>
      </div>

      <!-- package  -->
      <b-form-group
        v-if="userEmail == 'lt_techteam@visipoint.com'"
        class="form-section"
      >
        <div>
          <h5 class="Temp-head">
            {{ $t("companyDetails.form.subscription") }}
          </h5>
        </div>

        <div style="margin-inline-start: 39px">
          <v-radio-group v-model="form.entity.package">
            <v-radio
              v-for="option in companyOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
        </div>

        <div class="form-radio-wrapper__info">
          <p v-if="form.entity.package == 'Standalone'" class="textt-muted">
            <strong style="white-space: nowrap;">{{$t('common.notes.note')}} :</strong> {{ $t('companyDetails.notes.expectedSync') }}
          </p>
        </div>
      </b-form-group>

      <div>
        <!-- Company Plan radio buttons -->
        <b-form-group v-if="showCompanyPlanField" class="form-section">
          <div>
            <h5 class="Temp-head">{{ $t("companyDetails.form.plan") }}</h5>
          </div>
          <div style="margin-inline-start: 39px">
            <v-radio-group v-model="planValue">
              <v-radio
                v-for="option in planOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
          </div>
        </b-form-group>
      </div>

      <!-- <div class="seperator-line"></div> -->

      <!-- phone  -->
      <b-form-group class="form-section" id="name-group" label-for="phone">
        <div
          v-if="companyHasPhone"
          class="current-phone d-flex align-items-center"
        >
          <h5 class="vp-mr-48">{{ $t("common.phone") }}</h5>
          <p class="mb-0">{{ form.entity.company_phone }}</p>
          <a @click="updatePhone" class="change-text vp-ml-32">{{
            $t("common.change")
          }}</a>
        </div>

        <div v-else class="phone-input-wrapper">
          <VueCountryCode
            :enabledCountryCode="true"
            :preferredCountries="['GB']"
            @onSelect="onSelectCompanyCountryCode"
            label-cols-sm="2"
            class="phone-input"
          >
          </VueCountryCode>

          <b-form-input
            id="phone"
            type="text"
            :placeholder="$t('common.enterPhone')"
            v-model="form.entity.company_phone"
            class="phone-input phone-input_custom"
            label-cols-sm="7"
            :class="{
              'is-invalid': submitted && $v.form.entity.company_phone.$error,
            }"
          >
          </b-form-input>

          <div
            v-if="submitted && !$v.form.entity.company_phone.required"
            class="invalid-feedback"
          >
            <span class="no-wrap">{{
              $t("common.validation.phoneErrorRequired")
            }}</span>
          </div>

          <div
            v-if="submitted && !$v.form.entity.company_phone.numeric"
            class="invalid-feedback"
          >
            <span class="no-wrap">
              {{ $t("common.validation.phoneErrorOnlyNumbers") }}</span
            >
          </div>
        </div>
      </b-form-group>

      <div class="seperator-line2"></div>

      <!-- Temperature Unit -->
      <b-form-group label-for="temperature" class="form-section">
        <div>
          <h5 class="Temp-head">{{ $t("common.temperatureUnit") }}</h5>
        </div>
        <div style="margin-inline-start: 39px">
          <v-radio-group
            v-model="form.entity_setting.temperature_display_unit_for_company"
          >
            <v-radio
              v-for="option in options"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
        </div>
      </b-form-group>
      <div v-if="showCompanyTwoStepSection">
        <div class="custom-radio-switch vp-ml-38 vp-mb-5">
          <p class="label">{{ $t("companyDetails.form.twoAuth") }}</p>
          <b-form-checkbox
            class="switch-gray custom-switch-input"
            switch
            size="lg"
            v-model="enableCompanyOtpAuth"
            @input="changeCompanyOtpAuth"
          />
        </div>

        <div class="two-step-auth-note">
          <p class="two-step-auth-note-text">
            <b>{{ $t("common.notes.note") }}: </b
            >{{ $t("companyDetails.notes.twoAuth") }}
          </p>
        </div>

        <div v-if="enableCompanyOtpAuth">
          <VpTreeselect
            class="vp-ml-38 vp-mb-5 vp-mt-15"
            zIndex="12"
            :showPlaceholderIcon="true"
            width="416"
            :showOptionsBorder="true"
            :showNoResults="true"
            v-model="roles"
            :options="rolesOptions"
            :allowEmpty="true"
            :show-labels="true"
            :isLoading="userRolesLoading"
            :label="$t('common.userRole')"
            :disabled="!rolesOptions.length"
            noResultMessage="No results found"
            dropDownStyle="relative"
          />
        </div>
      </div>
    </div>

    <!-- action btns  -->
    <div class="d-flex justify-content-center align-items-center changes-btn">
      <button
        class="submit-btn btn btn-primary"
        @click="onSubmit"
        :disabled="getLoading || disableButton || !isDirty"
      >
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
        <span v-else> {{ $t("common.saveChanges") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { numeric, required } from "vuelidate/lib/validators";
import VueCountryCode from "vue-country-code";

export default {
  name: "EntityForm",
  components: { VueCountryCode },
  props: ["cropImageData"],
  data() {
    return {
      options: [
        { text: `°${this.$t("common.temperatureUnits.f")}`, value: "f" },
        { text: `°${this.$t("common.temperatureUnits.c")}`, value: "c" },
      ],
      companyOptions: [
        {
          text: this.$t("common.subscriptions.standalone"),
          value: "Standalone",
        },
        { text: this.$t("common.subscriptions.cloud"), value: "Cloud" },
      ],
      planOptions: [
        { text: this.$t("common.plans.lite"), value: 1 },
        { text: this.$t("common.plans.professional"), value: 2 },
        { text: this.$t("common.plans.enterprise"), value: 3 },
      ],
      currentEntityPackage: null,
      currentEntityPlan: null,
      planValue: 3,
      isDirty: false,
      disableButton: false,
      id: null,
      form: {
        entity: {
          company_phone: null,
          package: "Standalone",
        },
        entity_setting: {
          temperature_display_unit_for_company: null,
          force_otp: 0,
        },
        otp_roles: [],
      },
      submitted: false,
      logoLoaded: false,
      logoUrl: null,
      logo: {
        size: "",
        height: "",
        width: "",
        url: "",
      },
      fileImage: "",
      fileImageChanged: false,
      logoError: false,
      companyCountryCode: "",
      companyHasPhone: true,
      enableCompanyOtpAuth: false,
      rolesOptions: [],
      userRolesLoading: true,
      roles: [],
    };
  },
  validations: {
    form: {
      entity: {
        company_phone: { required, numeric },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("authfack", ["userDetails"]),
    ...mapGetters("entity", [
      "getEntities",
      "getLoading",
      "getIsValidSubdomian",
      // "getCropImageData"
    ]),
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
    // Add a computed property to determine whether to show the Company Plan field
    showCompanyPlanField() {
      return (
        this.form.entity.package === "Cloud" &&
        this.userEmail === "lt_techteam@visipoint.com"
      );
    },
    showCompanyTwoStepSection() {
      return (
        this.userDetails.is_owner ||
        this.userEmail === "lt_techteam@visipoint.com"
      );
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("editEntity");
    },
    // getCropImageData(data){
    //   this.logoError = false;
    //   this.logo.width = '';
    //   this.logo.height = '';
    //   this.logo.url = '';
    //   // let file = e.target.files[0];
    //   let file = data.croppedFile;
    //   // console.log('file',file)
    //   if(!file || file.type.indexOf('image/') !== 0) return this.logoError = true;
    //   this.logo.size = file.size;
    //   let reader = new FileReader();
    //   reader.readAsDataURL(file);
    //   reader.onload = evt => {
    //     let logo = new Image();
    //     logo.onload = () => {
    //        if( logo.width < 200 || logo.height < 45 || this.logo.size > 2097152 ) {
    //         return this.logoError = true;
    //       }
    //       this.logo.width = logo.width;
    //       this.logo.height = logo.height;
    //       this.logoLoaded = true;
    //       // this.logo.url = URL.createObjectURL(file);
    //       this.logo.url = data.croppedImageURI;

    //     }
    //     logo.src = evt.target.result;
    //     this.fileImageChanged = true;
    //     this.fileImage = file;
    //     // console.log('this.form',this.form);
    //   }
    //   reader.onerror = evt => {
    //     console.error(evt);
    //   }
    // },

    cropImageData(file) {
      this.disableButton = true;
      if (file) {
        // console.log("fileeeee", file);

        this.logoError = false;
        this.logo.width = "";
        this.logo.height = "";
        this.logo.url = "";

        // if (!file || file.type.indexOf("image/") !== 0) return this.logoError = true ;
        if (file.width < 200 || file.height < 45 || file.size > 2097152)
          return (this.logoError = true);

        this.logo.size = file.size;
        this.logo.width = file.width;
        this.logo.height = file.height;

        // console.log("this.logo", this.logo);

        this.fileImageChanged = true;
      }

      setTimeout(() => {
        this.disableButton = false;
        this.fileImage = file.blobFile;
        this.logo.url = file.cropedImage;
      }, 500);
    },
    form: {
      handler: "checkDirty",
      deep: true,
      immediate: true,
    },
    planValue: {
      handler: "checkDirty",
      deep: true,
      immediate: true,
    },
    logo: {
      handler: "checkDirty",
      deep: true,
      immediate: true,
    },
    roles: {
      handler: "checkDirty",
      deep: true,
      immediate: true,
    },
    enableCompanyOtpAuth(value) {
      this.form.entity_setting.force_otp = value ? 1 : 0; //to solve an issue if submitted the value of toggle resets
    },
  },
  methods: {
    ...mapActions("entity", ["updateEntity"]),
    ...mapActions("authfack", ["updateEntityPackage", "updateEntityPlan"]),
    ...mapActions("users", ["fetchUserRoles"]),
    getPlanName(plan) {
      let planText = "";
      switch (plan) {
        case 1:
          planText = "Lite";
          break;
        case 2:
          planText = "Professional";
          break;
        case 3:
          planText = "Enterprise";
          break;
        default:
          planText = "Enterprise";
          break;
      }
      return planText;
    },
    checkDirty() {
      const {
        form,
        logo,
        planValue,
        getModalInfo,
        enableCompanyOtpAuth,
        roles,
      } = this;
      const entity = form.entity;
      const entity_setting = form.entity_setting;
      const { company_phone, package: formPackage } = entity;
      const {
        logo: modalLogo,
        package: modalPackage,
        plan,
        setting,
      } = getModalInfo;

      let isDirty = false;

      if (
        this.companyCountryCode + "" + company_phone !=
          getModalInfo.company_phone ||
        logo.url != modalLogo ||
        formPackage != modalPackage ||
        planValue != plan
      ) {
        isDirty = true;
      }

      if (setting) {
        setting.forEach((row) => {
          if (row.name === "temperature_display_unit_for_company") {
            const val = row.pivot ? row.pivot.value : "";
            if (entity_setting.temperature_display_unit_for_company !== val) {
              isDirty = true;
            }
          } else if (row.name === "force_otp") {
            const val = row.pivot?.value;
            if (entity_setting.force_otp != val) {
              isDirty = true;
            }
          }
        });
      }

      if (enableCompanyOtpAuth && !roles.length) {
        isDirty = false;
      }

      if (enableCompanyOtpAuth && roles.length) {
        if (enableCompanyOtpAuth && roles.length != form.otp_roles.length)
          isDirty = true;
        roles.map((role) => {
          if (!form.otp_roles.includes(role)) {
            isDirty = true;
          }
        });
      }

      this.isDirty = isDirty;
    },
    changeCompanyOtpAuth() {
      if (!this.enableCompanyOtpAuth) this.roles = [];
    },
    async onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.form.entity.company_phone =
          this.companyCountryCode + this.form.entity.company_phone;
        this.form.entity.plan = this.getPlanName(+this.planValue);
        const { id, form, fileImage, fileImageChanged, roles } = this;

        let formData = new FormData();
        formData.append("logo", fileImage);
        formData.append("fileImageChanged", fileImageChanged);
        formData.append("entity", JSON.stringify(form.entity));
        formData.append("entity_setting", JSON.stringify(form.entity_setting));
        formData.append("otp_roles", JSON.stringify(roles));
        // console.log('formData',formData);
        /** Emit socket event on changing entity plan/subscription */
        if (this.userEmail == "lt_techteam@visipoint.com") {
          if (this.form.entity.package !== this.currentEntityPackage) {
            this.updateEntityPackage(this.form.entity.package);
            // this.$socket.emit('pingUpdateEntityPackage',{ package: this.form.entity.package ,entity: this.id , entityPlan: this.form.entity.plan })
          } else if (+this.planValue !== this.currentEntityPlan) {
            this.updateEntityPlan(this.form.entity.plan);
            // this.$socket.emit('pingUpdateEntityPlan',{entity: this.id , entityPlan: this.form.entity.plan })
          }
        }
        this.updateEntity({
          id: id,
          params: formData,
        }).then(async () => {
          this.$bvModal.hide("editEntity");
        });
      }
    },
    pickImage() {
      // document.getElementById('imagePicker').click();
      this.$bvModal.hide("editEntity");
      this.$bvModal.show("cropImageModal");
    },
    removeImage() {
      this.logo.url = "";
      this.fileImage = "";
      this.fileImageChanged = true;
    },
    onFileChange(e) {
      this.logoError = false;
      this.logo.width = "";
      this.logo.height = "";
      this.logo.url = "";
      let file = e.target.files[0];
      // console.log('file',file)
      if (!file || file.type.indexOf("image/") !== 0)
        return (this.logoError = true);
      this.logo.size = file.size;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let logo = new Image();
        logo.onload = () => {
          if (
            logo.width < 200 ||
            logo.height < 45 ||
            this.logo.size > 2097152
          ) {
            return (this.logoError = true);
          }
          this.logo.width = logo.width;
          this.logo.height = logo.height;
          this.logoLoaded = true;
          this.logo.url = URL.createObjectURL(file);
        };
        logo.src = evt.target.result;
        this.fileImageChanged = true;
        this.fileImage = file;
        // console.log('this.form',this.form);
      };
      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
    onSelectCompanyCountryCode({ dialCode }) {
      this.companyCountryCode = dialCode;
    },
    updatePhone() {
      this.companyHasPhone = false;
      this.form.entity.company_phone = null;
    },
    ImageData(file) {
      this.logoError = false;
      this.logo.width = "";
      this.logo.height = "";
      this.logo.url = "";

      console.log("fileeeee", file);

      if (!file || file.type.indexOf("image/") !== 0)
        return (this.logoError = true);
      if (file.width < 200 || file.height < 45 || file.size > 2097152)
        return (this.logoError = true);

      this.logo.size = file.size;
      this.logo.width = file.width;
      this.logo.height = file.height;
      this.logo.url = file.cropedImage;

      console.log("this.logo", this.logo);

      this.fileImageChanged = true;
      this.fileImage = file.blobFile;
      console.log("this.fileImage", this.fileImage);
    },
  },
  async beforeMount() {
    await this.fetchUserRoles().then(async (data) => {
      this.rolesOptions = data.data;
      this.userRolesLoading = false;
    });

    const { getModalInfo } = this;
    if (getModalInfo) {
      // console.log('company data modal', this.getModalInfo);
      this.id = getModalInfo.id;
      if (!getModalInfo.company_phone) {
        this.companyHasPhone = false;
      }
      this.form.entity.company_phone = getModalInfo.company_phone;
      this.form.entity.company_email = getModalInfo.company_email;
      this.logo.url = getModalInfo.logo;
      this.form.entity.package = getModalInfo.package;
      this.currentEntityPackage = getModalInfo.package;
      this.currentEntityPlan = getModalInfo.plan;
      this.planValue = getModalInfo.plan;
      if (getModalInfo.setting) {
        getModalInfo.setting.forEach((row) => {
          if (row.name == "temperature_display_unit_for_company") {
            this.form.entity_setting.temperature_display_unit_for_company =
              row.pivot ? row.pivot.value : "";
          } else if (row.name == "force_otp") {
            this.form.entity_setting.force_otp = row.pivot?.value;
            this.enableCompanyOtpAuth = row.pivot?.value == 1 ? true : false;
          }
        });
      }

      if (
        this.enableCompanyOtpAuth &&
        getModalInfo.otp_roles &&
        getModalInfo.otp_roles.length
      ) {
        getModalInfo.otp_roles.map((role) => {
          this.roles.push(role.id);
          this.form.otp_roles.push(role.id);
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-dangerr {
  width: 364px;
  margin: 12px auto 0px auto;

  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 19px !important;
  text-align: center;
  letter-spacing: 0.25px !important;
  color: #f46a6a !important;
  opacity: 0.8 !important;
}
.current-phone.d-flex.align-items-center {
  margin-inline-start: 39px;
}
.d-flex.justify-content-center.align-items-center.changes-btn {
  margin: 56px auto 33px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  text-transform: capitalize;
}
button.submit-btn.btn.btn-primary {
  width: 415px !important;
  height: 44px !important;
  border-radius: 22px;

  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  text-transform: capitalize;

  text-align: center;
  letter-spacing: 0.25px;

  color: rgba(255, 255, 255, 0.87);
}

h5.Temp-head {
  margin-inline-start: 39px;

  font-weight: 700;
  font-size: 16px;
  line-height: 188.5%;
  color: #787878;
  margin-bottom: 28px;
}
.phone-input-wrapper {
  display: grid;
  grid-template-columns: 106px 294px;
  margin-inline-start: 38px !important;
  height: 55px !important;
}
.phone-input {
  background: #f2f2f2;
  border: none;
  border-radius: 4px !important;
  height: 55px !important;
}
.seperator-line {
  height: 1px;
  width: 415px !important;
  margin: 0px auto 39px auto;
  background: #000000;
  opacity: 0.08;
}
.seperator-line2 {
  height: 1px;
  width: 415px !important;
  margin: 0px auto 25px auto;
  background: #000000;
  opacity: 0.08;
}
.textt-muted {
  display: flex;
  gap: 3px;
  justify-content: center;

  font-weight: 700 !important;
  font-size: 12px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  margin: 34px auto 0px auto;
  width: 370px;
  color: #939393 !important;
  opacity: 0.8 !important;
}
p.text-muted {
  font-weight: 700 !important;
  font-size: 12px !important;
  line-height: 17px !important;
  margin-bottom: 20px !important;

  text-align: center;
  letter-spacing: 0.25px !important;
  margin: 0px auto 33px auto;
  width: 304px;
  color: #939393 !important;

  opacity: 0.8 !important;
}
.kiosk-form-wrapper {
  padding: 0;
  .form-section {
    margin: 30px 0;

    &:first-child {
      margin-top: 0;
    }
  }
  h4 {
    color: #000000;
    font-size: 17px;
  }
  p {
    font-size: 12px;
  }
  .camera-BG {
    display: inline-flex;
    width: 106px;
    height: 106px;
    align-items: center;
    justify-content: center;
    background: #f2f2f2;
    border-radius: 50%;
    text-align: center;
    margin-bottom: 12px;
    border: none;
  }

  .red-border {
    border: 1.5px solid #f46a6a;
  }

  .img-company-bg {
    width: 383px;
    height: 107px;
    border: none;
    opacity: 0.45;
    border-radius: 18px;
    position: relative;
  }

  .mdi {
    font-size: 25pt;
    color: #8c8c8c;
    opacity: 0.65;
  }

  .close-btn {
    position: absolute;
    top: 6%;
    inset-inline-end: 5%;
    cursor: pointer;
    color: red;
  }
}

.remove-company-logo-btn {
  position: absolute;
  top: 175px;
  inset-inline-start: 45%;
  width: 68px;
  height: 25px;
  border: none;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #ffffff;
  border-radius: 16px;
  background: #f46a6a;
  z-index: 5 !important;
}

.phone-input_custom {
  width: calc(100% - 15px);
  margin-inline-start: auto;
}

.change-text {
  text-decoration: underline !important;
  color: #50a5f1;
}
</style>
<style lang="scss">
div#editEntity {
  div#editEntity___BV_modal_content_ {
    margin: 59px auto;
  }
  div#editEntity___BV_modal_body_ {
    padding: 0px !important;
    .form-radio-wrapper_custom {
      margin-inline-start: 38px;
    }

    .page-headercon {
      .header-titlename {
        width: 100%;
        h4.edit-company {
          margin-top: 41px;
          margin-bottom: 42px;

          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          text-align: center;

          color: #000000;
        }
      }
    }

    .custom-radio-switch {
      width: 416px;
      height: 55px;
      flex-shrink: 0;
      border-radius: 4px;
      background: #f2f2f2;
      display: flex;
      padding-inline-start: 20px;
      padding-inline-end: 20px;
      position: relative;
      justify-content: space-between;
      .label {
        color: var(--787878, #787878);
        font-size: 16px;
        font-weight: 700;
        line-height: 19.2px;
        margin-top: 20px;
      }

      .switch-gray {
        margin-top: 15px;

        .custom-control-input:checked ~ .custom-control-label::before {
          position: absolute;
          top: 6px !important;
          width: 43px;
          height: 21px;
          background: #d1d1d1;
          border: 1.5px solid #d1d1d1 !important;
          border-radius: 13.5px;
        }

        .custom-control-input:checked ~ .custom-control-label::after {
          width: 21px !important;
          height: 21px !important;
          top: 6px !important;
          background-color: #34c38f;
        }

        .custom-control-label::before {
          top: 6px !important;
          width: 43px !important;
          height: 21px !important;
          background: #d1d1d1;
          border: 1.5px solid #d1d1d1 !important;
          border-radius: 13.5px;
        }
        .custom-control-label::after {
          width: 21px !important;
          height: 21px !important;
          top: 6px !important;
          background: #939393;
          box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.18) !important;
        }
      }
    }

    .two-step-auth-note {
      margin-inline-start: 38px;
      width: 416px;
      .two-step-auth-note-text {
        font-size: 14px;
        font-weight: 400;
        line-height: 19px;
        letter-spacing: 0.25px;
        text-align: start;
        color: #939393;
      }
    }
  }
}
</style>
